export const GET_ALL_APPROVAL = `
    query GetAllApproval($input:TapprovalWhereInput,$skip:Float,$take:Float){
        getApproval(where:$input,skip:$skip,take:$take){
            pageInfo{
                currentPage
                hasNextPage
                hasPreviousPage
                itemsPerPage
                totalItems
                totalPages
            }
            items{
                id
                name
                plantId
                approvalType
                createDate
                createId
                modifyId
                modifyDate
                tmodifyUser {
                    fullName
                }
            }
        }
    }
`;

export const GET_APPROVAL_DETAIL = `
    query GetAllApprovalDetail($input: TapprovalDetailWhereInput,  $skip: Float, $take: Float ){
        getApprovalDetail(where: $input, skip: $skip, take: $take, orderBy:{createDate: DESC}){
            pageInfo{
                currentPage
                hasNextPage
                hasPreviousPage
                itemsPerPage
                totalItems
                totalPages
            }
            items{
                id
                approvalId
                userId
                indexNum
                level
                plantId
                tuser{
                    id
                    email
                    plantCode
                }
                tcreateUser{
                    id
                    fullName
                }
                tmodifyUser{
                    id
                    fullName
                }
                useYn
                type
                createId
                createDate
                modifyId
                modifyDate
            }
        }
    }
`;

export const ADD_APPROVAL_DETAIL = `
    mutation AddApprovalDetail($input: TapprovalDetailInput! ){
        createApprovalDetail(input: $input){
            id
            approvalId
            useYn
            userId
            level
            indexNum
        }
    }
`;

export const UPDATE_APPROVAL_DETAIL_STATUS = `
    mutation TurnOnOffApprovalDetail($input: TapprovalDetailInput! ){
        updateApprovalDetail(input: $input){
            id
            approvalId
            useYn
        }
    }
`;

export const UPDATE_APPROVAL_DETAIL = `
    mutation DeleteApprovalDetail($input: TapprovalDetailInput! ){
        updateApprovalDetail(input: $input){
            id
            approvalId
            useYn
            userId
            level
            indexNum
        }
    }
`;

export const CHECK_CREATE_APPROVAL_DETAIL = `
    query CheckInsertApprovalDetail($input:CheckInsertApprovalInput!){
        CheckInsertApprovalDetail(where:$input){
            message
            status
        }
    }
`;

export const UPDATE_STATUS_APPROVAL_DETAIL = `
    mutation DeleteApprovalDetail($input: TapprovalDetailInput! ){
        updateApprovalDetail(input: $input){
            id
            approvalId
            useYn
        }
    }
`;

export const DELETE_APPROVAL_DETAIL = `
    mutation DeleteApprovalDetail($input: String! ){
        deleteApprovalDetail(id: $input){
            success
            message
            code
        }
    }
`;
